import { axiosInstance } from 'boot/axios';

export function getMemberOffers({ commit }, collectivityLabel) {
  commit('setLoading', true);
  return axiosInstance.get(`MemberOffer/${collectivityLabel}`).then((response) => {
    if (response.status === 200) {
      const sortedData = response.data.sort((a, b) => {
        const aVal = a.order ?? Infinity;
        const bVal = b.order ?? Infinity;

        return aVal - bVal;
      });

      commit('setMemberOffers', sortedData);
    }
    commit('setLoading', false);
  });
}

export function postTip(_, payload) {
  return axiosInstance.post('MemberOffer/Tip', payload);
}
